import FadeUp from "@/components/landing/FadeUp";
import { HOW_IT_WORKS } from "./content";
import { SectionHeading } from "./Primitives";

export const HowItWorks = () => (
    <section id="how-it-works" data-testid="how-it-works-section" className="section-pad bg-white">
        <div className="container-page">
            <SectionHeading
                eyebrow="How it works"
                title={HOW_IT_WORKS.heading}
                sub={HOW_IT_WORKS.sub}
                testId="how-it-works-heading"
            />

            <ol className="relative mt-14 md:mt-20 lg:grid lg:grid-cols-5 lg:gap-6">
                <div aria-hidden className="hidden lg:block absolute top-5 left-[10%] right-[10%] h-px bg-hire-line" />
                {HOW_IT_WORKS.steps.map((s, i) => {
                    const last = i === HOW_IT_WORKS.steps.length - 1;
                    return (
                        <FadeUp key={s.title} as="li" delay={i * 0.06} className="relative flex lg:block gap-5 pb-10 lg:pb-0">
                            {!last && (
                                <span aria-hidden className="lg:hidden absolute left-5 top-10 bottom-0 w-px bg-hire-line" />
                            )}
                            <div className="relative z-10 h-10 w-10 shrink-0 rounded-full border border-hire-line bg-white grid place-items-center text-[13px] font-bold text-brand-blue shadow-[0_1px_2px_rgba(11,15,25,0.06)]">
                                {String(i + 1).padStart(2, "0")}
                            </div>
                            <div className="lg:mt-6 pt-1.5 lg:pt-0">
                                <h3 data-testid={`step-title-${i + 1}`} className="text-[17px] font-semibold text-hire-ink leading-snug">
                                    {s.title}
                                </h3>
                                <p className="mt-2.5 text-[14.5px] text-hire-muted leading-relaxed text-pretty">
                                    {s.body}
                                </p>
                            </div>
                        </FadeUp>
                    );
                })}
            </ol>

            <FadeUp delay={0.1}>
                <div
                    data-testid="hiring-stats"
                    className="mt-10 md:mt-20 rounded-2xl border border-hire-line bg-hire-bg p-6 md:p-8"
                >
                    <div className="grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-hire-line">
                        {HOW_IT_WORKS.stats.map((st) => (
                            <div key={st.label} className="py-4 sm:py-0 sm:px-8 first:pl-0 last:pr-0">
                                <p className="text-3xl md:text-[36px] font-extrabold tracking-tight text-hire-ink">
                                    {st.value}
                                </p>
                                <p className="mt-1 text-sm text-hire-muted">{st.label}</p>
                            </div>
                        ))}
                    </div>
                    <p className="mt-6 pt-5 border-t border-hire-line text-[13px] text-hire-muted">
                        {HOW_IT_WORKS.statsNote}
                    </p>
                </div>
            </FadeUp>
        </div>
    </section>
);

export default HowItWorks;
